import React from "react";

const AboutList = ({ entries, onEdit, onDelete, onCreate }) => {
  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>About Entries</h3>
              <button className="btn btn-primary mb-3" onClick={onCreate}>
                + Create New
              </button>
            
            <div  className="box-body">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Heading</th>
                    <th>Paragraph</th>
                    <th>Image</th>
                    <th style={{ width: "150px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No entries found.
                      </td>
                    </tr>
                  ) : (
                    entries.map((entry, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{entry.heading}</td>
                        <td
                          style={{
                            maxWidth: 50,
                            overflow: "hidden",
                            textOverflow: "intial",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {entry.para}
                        </td>
                        <td>
                          {entry.imagePreview && (
                            <img
                              src={entry.imagePreview}
                              alt="Preview"
                              style={{ width: "100px", borderRadius: 6 }}
                            />
                          )}
                        </td>
                        <td>
                          <div>
                            <button
                              className="btn btn-primary btn-sm me-2"
                              onClick={() => onEdit(index)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => onDelete(index)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutList;
